module.exports = __webpack_public_path__ + "img/imgselected.97cd3f95.png";